import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DietitianState,
  DietitianStateProvider,
} from '../../../../../../../../data/dietitian/domain/dietitian_state_provider';
import { PatientGroupEventProvider } from '../../../../../../../../data/dietitian/domain/events/patient_group_event_provider';
import { PatientGroup } from '../../../../../../../../data/dietitian/domain/patient_group/patient_group';
import { PatientGroupCommands } from '../../../../../../../../data/dietitian/domain/patient_group/patient_group_commands';
import { Patient } from '../../../../../../../../data/patient/domain/patient';

@Injectable()
export class RemovePatientFromGroupModalFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private patientGroupEventProvider: PatientGroupEventProvider,
    private patientGroupCommands: PatientGroupCommands,
  ) {
    // Nada
  }

  get dietitianState$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$;
  }

  getDietitianPatientGroups(dietitianId: string): Promise<PatientGroup[]> {
    return this.patientGroupCommands.getDietitianPatientGroups(dietitianId);
  }

  async removeAllPatientsFromGroup(
    dietitianId: string,
    patientIds: string[],
    selectedGroupId: string,
  ): Promise<Patient[]> {
    return this.patientGroupCommands.removeMultiPatientsFromGroup(
      dietitianId,
      patientIds,
      selectedGroupId,
    );
  }

  async removePatientFromGroup(
    dietitianId: string,
    patientId: string,
    selectedGroupId: string,
  ) {
    await this.patientGroupCommands.removeSinglePatientFromGroup(
      dietitianId,
      patientId,
      selectedGroupId,
    );
  }
}
